kv.controller('DashboardMarketingListUpcomingEventsCtrl', function ($element, $attrs, $scope, $injector) {
	var vm = new DashboardWidgetListCtrl($element, $attrs, $scope, $injector);
	return vm;
});
